//* 组件库
import { type UiTableOption2 } from "various-ui";

//* 基因表格
export const useGeneOption = () => {
    const i18n = useI18n();
    const result: UiTableOption2[] = [
        { key: "species", slot: "species", name: i18n.t("Species"), align: "singularity" },
        { key: "gene_name", slot: "name", sort: true, name: i18n.t("Layout.TypeName2", { type: "Gene" }, 2), align: "singularity" },
        { key: "alias", slot: "alias", name: i18n.t("Alias2"), align: "singularity" },
    ];

    return result;
};

//* 模型表格
export const useModelOption = () => {
    const i18n = useI18n();
    const result: UiTableOption2[] = [
        { key: "type", name: i18n.t("Category", { type: "Model" }), align: "center" },
        { key: "name", slot: "name", name: i18n.t("Layout.TypeName", { type: "Model" }, 2), align: "singularity" },
        { key: "rel_gene_name", slot: "gene", sort: true, name: i18n.t("Layout.TypeRelated", { type: "Genes" }, 2), align: "center" },
        { key: "strain", slot: "strain", name: i18n.t("StrainOrigin", 2), align: "center" },
        { key: "related_disease", slot: "disease", name: i18n.t("Layout.TypeRelated", { type: "Diseases" }, 2), align: "center" },
        { key: "reference_count", sort: true, name: i18n.t("Publications"), align: "center" },
    ];

    return result;
};

//* 疾病表格
export const useDiseaseOption = () => {
    const i18n = useI18n();
    const result: UiTableOption2[] = [
        { key: "full_name", slot: "name", sort: true, name: i18n.t("Layout.TypeName", { type: "Disease" }, 2), align: "singularity" },
        { "key": "inheritance", "max-width": 232, "slot": "inheritance", "name": i18n.t("Inheritance"), "align": "singularity" },
        { "key": "categories_icon", "max-width": 152, "slot": "categories", "name": i18n.t("AnatomicalCategory", 2), "align": "singularity" },
        { key: "rare", slot: "rare", name: i18n.t("RareDiseases"), align: "center" },
        { key: "rel_gene_name", slot: "gene", name: i18n.t("Layout.TypeRelated", { type: "Genes" }, 2), align: "center" },
    ];

    return result;
};

//* 突变表格
export const useMutationOption = () => {
    const i18n = useI18n();
    const result: UiTableOption2[] = [
        { key: "gene", name: i18n.t("Genes"), slot: "gene", align: "center" },
        { key: "mutation_transcript", name: i18n.t("Nucleotide"), slot: "mutation_transcript", align: "center" },
        { key: "mutation_protein", name: i18n.t("AminoAcid"), slot: "mutation_protein", align: "center" },
        { key: "transcript", name: i18n.t("TranscriptID"), slot: "transcript", align: "center" },
        { key: "variant_type", name: i18n.t("MutationType"), slot: "mutation_type", align: "center" },
        { key: "clinical", name: i18n.t("ClinicalSignificance"), slot: "clinical", align: "center" },
        { key: "disease_qty", name: i18n.t("DiseaseCount"), slot: "disease_qty", align: "center" },
        { key: "references", name: i18n.t("Publications"), slot: "references", align: "center" },
    ];
    return result;
};

//* 工具表格
export const useToolOption = () => {
    const i18n = useI18n();
    const result: UiTableOption2[] = [
        { key: "name", name: i18n.t("ToolName"), align: "center", slot: "name" },
        { key: "introduction", name: i18n.t("ToolIntroduction"), align: "center" },
        { key: "operate", name: i18n.t("Operate"), align: "center", slot: "operate", width: 150 },
    ];
    return result;
};
